import { ResponseBase } from './base/ResponseBase';
import { Question } from '../models/Question';
import { Expose } from 'class-transformer';

export class QuestionResponse extends ResponseBase {
        @Expose({ name: 'results' })
        question?: Question;
}